var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz3__toolbar",class:{
        'cz3__toolbar--important': _vm.important,
        'cz3__toolbar--justify': _vm.justify,
        'cz3__toolbar--no-scroll': _vm.noScroll,
        'cz3__toolbar--no-margins': _vm.noMargins,
    }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }